import React from 'react';
import { chartTheme } from './Theme';
import { niceTicks } from './utils';

const BarChart = ({ data = [], width = '100%', height = 180, color = chartTheme.colors.bar, labelFormatter }) => {
  const w = 600;
  const h = Number(height) || 180;
  const pad = chartTheme.layout.pad;
  const values = data.map(d => Number(d.value ?? d.count ?? 0));
  const categories = data.map(d => String(d.label ?? d.date ?? ''));
  const maxV = Math.max(1, ...values);
  const { ticks, max } = niceTicks(maxV, chartTheme.layout.yTicks);
  const barW = Math.max(1, Math.floor((w - pad * 2) / Math.max(1, data.length)));
  const scaleY = (v) => h - pad - (v / max) * (h - pad * 2);

  const allZero = values.length === 0 || values.every(v => (v || 0) === 0);
  if (allZero) {
    return (
      <div style={{ width: '100%', minHeight: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', fontSize: 12 }}>
        No data
      </div>
    );
  }

  return (
    <svg viewBox={`0 0 ${w} ${h}`} width={width} height="100">
      <rect x="0" y="0" width={w} height={h} fill="#ffffff"/>
      <line x1={pad} y1={h - pad} x2={w - pad} y2={h - pad} stroke={chartTheme.colors.axis} strokeWidth="1" />
      {ticks.map((t, i) => {
        const y = scaleY(t);
        return (
          <g key={i}>
            <line x1={pad} y1={y} x2={w - pad} y2={y} stroke={chartTheme.colors.grid} strokeWidth="1" />
            <text x={pad - 6} y={y + 3} textAnchor="end" fontSize={chartTheme.fonts.tickSize} fill={chartTheme.colors.axis}>
              {labelFormatter ? labelFormatter(t) : t}
            </text>
          </g>
        );
      })}
      {data.map((d, i) => {
        const x = pad + i * barW;
        const y = scaleY(values[i] || 0);
        const bh = h - pad - y;
        return (
          <g key={i}>
            <rect x={x + 6} y={y} width={barW - 12} height={bh} fill={color} rx="3">
              <title>{`${categories[i]}: ${values[i] || 0}`}</title>
            </rect>
            {data.length <= 12 && (
              <text x={x + barW / 2} y={h - pad + 14} textAnchor="middle" fontSize={chartTheme.fonts.tickSize} fill={chartTheme.colors.axis}>
                {categories[i]}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
};

export default BarChart;


